<div class="text-center">
    <h1 class="display-4">Welcome</h1>
    <img src="assets/images/thordraco.jpg" alt="ThorDraco Logo" />
    <br />
    Get some <a href="https://merch.streamelements.com/thordraco">THUNDER MERCH</a>
    <br />
</div>